<template>
  <v-expansion-panel>
    <ContactTemplate :Contact="CustomerContact"
                     :loading="loading">
    </ContactTemplate>
  </v-expansion-panel>
</template>


<script>
import ContactTemplate from "@/components/Preview/Customer/ContactTemplate.vue";

export default {
  name: "CustomerContactPreview",
  props: {
    CustomerContact: Object,
    loading: Boolean,
  },
  components: {
    ContactTemplate,
  },

  data: () => ({}),

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>